module.exports = __webpack_public_path__ + "img/thumbnail_EurasianLynx_j_normal.3c0d3453.png";